import { Head, usePage } from "@inertiajs/react";
import { Link } from "@inertiajs/react";
import { ArrowLeft } from "lucide-react";

import CollectionTemplateGrid from "@/theme1/components/collections/CollectionTemplateGrid";
import CollectionTemplateHeader from "@/theme1/components/collections/CollectionTemplateHeader";
import CollectionTemplateHero from "@/theme1/components/collections/CollectionTemplateHero";
import { Container } from "@/theme1/components/common/Container";
import { normalizeProducts } from "@/theme1/lib/productNormalizer";

export default function CollectionTemplate() {
  const { slug, collection: collectionProp = null } = usePage().props;

  const collection = collectionProp
    ? {
        ...collectionProp,
        products: normalizeProducts(collectionProp.products || []),
      }
    : null;

  if (!collection) {
    return (
      <>
        <Head title="Collection Not Found - Captex" />

        <Container className="py-20 sm:py-28">
          <section className="rounded-[2rem] border border-border bg-neutral-100/30 px-6 py-20 text-center">
            <p className="text-xs font-black uppercase tracking-[0.3em] text-muted-foreground">
              Collection
            </p>

            <h1 className="mt-5 text-4xl font-black uppercase tracking-tight sm:text-6xl">
              Collection not found.
            </h1>

            <p className="mx-auto mt-4 max-w-lg text-sm leading-7 text-muted-foreground">
              The requested collection is unavailable or may have moved.
            </p>

            <Link
              href="/collections"
              className="mt-8 inline-flex min-h-12 items-center justify-center gap-2 rounded-full bg-neutral-950 px-6 py-3 text-sm font-black uppercase text-white"
            >
              <ArrowLeft className="size-4" />
              View Collections
            </Link>
          </section>
        </Container>
      </>
    );
  }

  return (
    <>
      <Head title={collection.seo.title}>
        <meta
          name="description"
          content={collection.seo.description}
        />
      </Head>

      <main className="overflow-hidden">
        <Container className="py-5 sm:py-7 lg:py-10">
          <CollectionTemplateHero collection={collection} />



          <CollectionTemplateGrid

          
            products={collection.products}
          />
        </Container>
      </main>
    </>
  );
}
